import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import ToggleButton from '../gameobjects/ToggleButton';
import ToggleGroup from '../gameobjects/ToggleGroup';
import UIAssetKeys from '../UIAssetKeys';
import QuizGame from './QuizGame';
import FontKeys from '../FontKeys';

export default class SelectLevel extends Phaser.Scene
{
    static get KEY() { return 'SelectLevel'; }

    constructor()
    {
        super({ key: (SelectLevel).KEY });
    }

    create()
    {
        const bg = this.add.rectangle(0,0, this.scale.width, this.scale.height, 0x0f75bc).setOrigin(0);

        const selectAGameText = ABCyaPhaser.Text.addText(this.scale.width/2, 139, 38, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.options.select_a_game"), this, true).setOrigin(0.5);
        const selectDifficultyText = ABCyaPhaser.Text.addText(this.scale.width/2, 388, 38, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.options.select_difficulty"), this, true).setOrigin(0.5);

        let plusButton = new ToggleButton(this, this.scale.width / 2 - 300, this.scale.height / 2 - 120, UIAssetKeys._sprites_plus_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectPlusOp, this);

        let minusButton = new ToggleButton(this, this.scale.width / 2 - 100, this.scale.height / 2 - 120, UIAssetKeys._sprites_minus_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectMinusOp, this);

        let timesButton = new ToggleButton(this, this.scale.width / 2 + 100, this.scale.height / 2 - 120, UIAssetKeys._sprites_times_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectTimesOp, this);

        let divideButton = new ToggleButton(this, this.scale.width / 2 + 300, this.scale.height / 2 - 120, UIAssetKeys._sprites_divide_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectDivideOp, this);

        this._operationToggles = new ToggleGroup([plusButton, minusButton, timesButton, divideButton]);

        let oneButton = new ToggleButton(this, this.scale.width / 2 - 200, this.scale.height / 2 + 120, UIAssetKeys._sprites_1_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectDifficultyOne, this);

        let twoButton = new ToggleButton(this, this.scale.width / 2, this.scale.height / 2 + 120, UIAssetKeys._sprites_2_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectDifficultyTwo, this);

        let threeButton = new ToggleButton(this, this.scale.width / 2 + 200, this.scale.height / 2 + 120, UIAssetKeys._sprites_3_button).setScale(0).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectDifficultyThree, this);

        this._difficultyToggles = new ToggleGroup([oneButton, twoButton, threeButton]);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(plusButton, 250, { scale: 1.4, offset: 0 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(plusButton, 100, { scale: 1.2, offset: 250 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(minusButton, 250, { scale: 1.4, offset: 100 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(minusButton, 100, { scale: 1.2, offset: 350 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(timesButton, 250, { scale: 1.4, offset: 200 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(timesButton, 100, { scale: 1.2, offset: 450 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(divideButton, 250, { scale: 1.4, offset: 300 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(divideButton, 100, { scale: 1.2, offset: 550 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(oneButton, 250, { scale: 1.4, offset: 400 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(oneButton, 100, { scale: 1.2, offset: 650 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(twoButton, 250, { scale: 1.4, offset: 500 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(twoButton, 100, { scale: 1.2, offset: 750 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(threeButton, 250, { scale: 1.4, offset: 600 }, Phaser.Math.Easing.Quadratic.In),
                        ABCyaPhaser.Tweens.createTween(threeButton, 100, { scale: 1.2, offset: 850 }, Phaser.Math.Easing.Quadratic.Out),
                    ]
            }
        );
    }

    selectPlusOp()
    {
        gameData.operation = OPERATIONS.plus;
        this.checkIfDone();
    }

    selectMinusOp()
    {
        gameData.operation = OPERATIONS.minus;
        this.checkIfDone();
    }

    selectTimesOp()
    {
        gameData.operation = OPERATIONS.times;
        this.checkIfDone();
    }

    selectDivideOp()
    {
        gameData.operation = OPERATIONS.divide;
        this.checkIfDone();
    }

    selectDifficultyOne()
    {
        gameData.difficulty = 1;
        this.checkIfDone();
    }

    selectDifficultyTwo()
    {
        gameData.difficulty = 2;
        this.checkIfDone();
    }

    selectDifficultyThree()
    {
        gameData.difficulty = 3;
        this.checkIfDone();
    }

    checkIfDone()
    {
        if (this._operationToggles.getAnySelected() && this._difficultyToggles.getAnySelected())
        {
            this.scene.start(QuizGame.KEY);
        }
    }
}

export const OPERATIONS = {
    plus: "plus",
    minus: "minus",
    times: "times",
    divide: "divide",
}